import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import hooks1 from './assets/images/hooks1.png';
import hooks2 from './assets/images/hooks2.png';
import hooks3 from './assets/images/hooks3.png';
import context1 from './assets/images/context1.png';
import context2 from './assets/images/context2.png';
import context3 from './assets/images/context3.png';
import context4 from './assets/images/context4.png';



const ReactLesson15 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
       const [loading, setloading] = useState(false);

       //set state
       setLoading(true);

      `
    );
    const code1 = (
      'text',
      `
       useEffect(() => {
        //side effect code

        return () => {
          // cleanup code
        };
       }, []);



      `
    );
    const code2 = (
      'text',
      `
       import React, { useMemo } from 'react';

       function MyComponent({ someValue }) {
        const memorizedValue = useMemo (() => {
          //Expensive computation or caculation
          return computerExpensiveValue(someValue);
        }, [someValue]);

        //component rendering code, using memorizedValue.

        return (
          <div>
          {/*JSX of your component */}
        );
       }

      `
    );
    const code3 = (
      'text',
      `
       const MyContext = React.createContext();

      `
    );
    const code4 = (
      'text',
      `
       const MyContextProvider = ({ children }) => {
        const sharedValue = "Hello from Context!";
        return <MyContext.Provider
        value={sharedValue}>{children}</MyContext.Provider>;

       };

      `
    );
    const code5 = (
      'text',
      `
       import React, { useContext } from 'react';

       const MyComponent =() => {
        const contextValue = useContext(MyContext);

        return (
          <div>
          <p>{contextValue}</p>
          </div>
        );
       };



      `
    );
    const code6 = (
      'text',
      `
       const App = ( => {
        return (
          <MyContextProvider>
          <MyComponent />
          </MyContextProvider>
        );
       };



      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>React Hooks</strong></h3>
     <p>React Hooks are functions that enable developers to replace class components in functional components with state and other React capabilities. In React version 16.8, they were added to solve some of the drawbacks associated with utilizing class components in React.</p>
     <p>Class components predominantly employed lifecycle methods and state management prior to Hooks' debut. Functional components can now access other React features and have state thanks to Hooks, which were previously exclusive to class components. Reusing stateful logic between components is made simpler and more comprehensible with the help of hooks, which operate outside of classes.
    </p>
    <p>Several often used React Hooks include:</p>
    <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item"><strong>useState:</strong> It allows functional components to manage state. With useState, you can add state variables to functional components and update them using the provided setter function.
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
    <li class="list-group-item"><strong>useEffect:</strong> this is a React Hook that lets you run side scripts in your functional parts. Manually modifying the DOM, data fetching, and subscriptions are examples of side effects. UseEffect's main function is to manage operations that take place outside of your React components' regular workflow, such retrieving data from an API, subscribing to external events, or establishing timers.
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
    <li class="list-group-item"><strong>useMemo:</strong> this hook is used to memoize the outcome of a calculation. By remembering the value that a function returns, it helps to optimize performance by preventing the need to recompute it on each render unless there is a change in the dependencies. This is especially helpful for costly computations or computations that don't require frequent recalculations.

    <ol>
    <CopyBlock
                        language={"react"}
                        text={code2}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    <p><strong>useMemo</strong> is a utility that reduces needless recalculations, thereby improving efficiency in React apps. While useMemo might be helpful for performance optimization, it's crucial to use it sparingly because memorizing everything can result in code complexity and certain drawbacks such as greater memory usage. It works well in certain circumstances where there is a true need for performance improvements.</p>
    </li>
    </ol>

    <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item"><strong>useContext:</strong> Functional components now have a means to use values from the React environment thanks to this hook. Bypassing the need to explicitly transmit props via each tier of the component tree, react context allows components to share values, including themes, authentication status, and other data.
    <p>To create a React Context, we do the following:</p>
    <ol class="list-group list-group-numbered">
    <li class="list-group-item"><strong>Create a Context:</strong> First, you create a context using React.createContext()
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code3}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
     <li class="list-group-item"><strong>Create a Provider:</strong> Next, you define a provider component. The provider component will wrap the part of the component tree where you want to share the context.
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code4}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
    <li class="list-group-item"><strong>Consume the Context:</strong> Now, you can consume the context in any functional component using useContext.
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code5}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
    <li class="list-group-item"><strong>Wrap the Component Tree with Provider:</strong> Finally, you wrap the relevant part of your component tree with the provider.
    <ol>
    <CopyBlock
                        language={"react"}
                        text={code6}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />        </ol>
    </li>
    </ol>
    </li>
    </ol>

    <p><strong>useContext</strong> is most powerful when used with the <strong>Context.Provider</strong> higher up in the component tree. If the context is provided at a higher level, multiple components can access the shared values without needing to pass the values explicitly through each intermediate component.</p>
     <h3><strong>Summary</strong></h3>
    <p>Hooks follow specific naming conventions such as starting with the word "use" to allow React to identify them and manage their state correctly.
    The use of React Hooks has simplified the development of React applications, making functional components more powerful by enabling them to manage state and have lifecycle-like functionalities, previously available only in class components.</p>
    <br/><br/>

  </div>
      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson15
